import style from '../scss/style.scss'

function mobileAdjust() {
  const hero = document.querySelector('.hero')
  if (window.innerWidth < 768) {
    const navHeight = document.querySelector('.nav').clientHeight
    hero.style.marginTop =  navHeight * -1 + 'px'
  } else {
    hero.style.marginTop = 0
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('.nav__link')
  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()
      const target = event.target
      const href = target.href
      const i = href.indexOf('#')
      const dest = document.getElementById(href.substr(i + 1))
      const scroll = dest.getBoundingClientRect().top + window.pageYOffset
      console.log(dest, scroll)
      window.scroll({
        top: scroll,
        behavior: 'smooth',
      })
    })
  })

  const photos = document.querySelectorAll('.photo')
  photos.forEach((photo) => {
    const mainPhoto = photo.querySelector('.photo__main .photo__image')
    const thumbPhotos = photo.querySelectorAll('.photo__thumb .photo__frame')
    thumbPhotos.forEach((thumbPhoto) => {
      const changeImage = (event) => {
        const target = event.target
        const img = target.children[0] || target
        mainPhoto.src = img.src
      }
      if (window.ontouchstart === undefined) {
        thumbPhoto.addEventListener('mouseenter', changeImage)
      } else {
        thumbPhoto.addEventListener('touchend', changeImage)
      }
    })
  })

  const heroTitle = document.querySelector('.hero__title')
  heroTitle.style.opacity = 0
  const heroMessage = document.querySelector('.hero__message')
  heroMessage.style.opacity = 0

  mobileAdjust()
})

document.addEventListener('resize', () => {
  mobileAdjust()
})

document.addEventListener('scroll', () => {
  const hero = document.querySelector('.hero')
  const heroTop = hero.getBoundingClientRect().top
  if (heroTop <= 0) {
    hero.classList.add('hero--fadeIn')
  }

  const works = document.querySelectorAll('.work')
  works.forEach((work) => {
    const items = work.querySelectorAll('.work__item')
    items.forEach((item) => {
      const windowHeight = window.innerHeight
      const posTop = item.getBoundingClientRect().top
      const height = item.clientHeight / 2
      if ((windowHeight - posTop) > height) {
        item.classList.add('work__item--fadeIn')
      } else if ((windowHeight - posTop) <= 0) {
        item.classList.remove('work__item--fadeIn')
      }
    })
  })
})
